import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Box } from 'shared/mui/Box';
import { TooltipWithInfoIcon } from 'shared/mui/Tooltip';
import { BooleanInput, TextInput } from 'shared/react-admin/Inputs';

export const OrderConversionListGatewaySettingsForm: React.FC = () => {
  const translate = useTypedTranslate();

  return (
    <Box sx={{ display: 'flex', gap: '24px', flexDirection: 'column', marginTop: '8px' }}>
      <TextInput
        helperText={false}
        key="minOrdersCount"
        label={translate('app.orderConversion.minimumNumberOfOrders')}
        resettable
        slotProps={{
          input: {
            endAdornment: (
              <TooltipWithInfoIcon
                iconSize={20}
                tooltipText={translate(
                  'app.orderConversion.minimumHourlyOrderThresholdReddyNotifications',
                )}
              />
            ),
          },
        }}
        source="minOrdersCount"
        variant="outlined"
      />
      <TextInput
        helperText={false}
        key="successDeviation"
        label={translate('app.orderConversion.successfulOrdersDeviationPercentage')}
        resettable
        slotProps={{
          input: {
            endAdornment: (
              <TooltipWithInfoIcon
                iconSize={20}
                tooltipText={translate(
                  'app.orderConversion.orderConversionBelowAveragePercentagePoints',
                )}
              />
            ),
          },
        }}
        source="successDeviation"
        variant="outlined"
      />
      <TextInput
        helperText={false}
        key="cancelDeviation"
        label={translate('app.orderConversion.cancelledOrdersDeviationPercentage')}
        resettable
        slotProps={{
          input: {
            endAdornment: (
              <TooltipWithInfoIcon
                iconSize={20}
                tooltipText={translate('app.orderConversion.conversionBelowAvgPctPoints')}
              />
            ),
          },
        }}
        source="cancelDeviation"
        variant="outlined"
      />
      <TextInput
        helperText={false}
        key="pendingDeviation"
        label={translate('app.orderConversion.queueOrdersDeviationPercentage')}
        resettable
        slotProps={{
          input: {
            endAdornment: (
              <TooltipWithInfoIcon
                iconSize={20}
                tooltipText={translate('app.orderConversion.conversionAboveAvgPctPointsDesc')}
              />
            ),
          },
        }}
        source="pendingDeviation"
        variant="outlined"
      />
      <BooleanInput
        label={translate('app.orderConversion.enableGatewayNotificationsOnDeviation')}
        size="small"
        source="notify"
      />
    </Box>
  );
};
